angular.module('impactx.invoice').controller('InvoiceAcceptUnmatchedCtrl', [
    '$scope',
    'dataGen',
    'BackService',
    'ToastService',
    '$routeParams',
    'TranslationService',
    'ToolbarService',
    'DownloadService',
    '$window',
    InvoiceAcceptUnmatchedCtrl
]);

function InvoiceAcceptUnmatchedCtrl($scope, dataGen, BackService, ToastService, $routeParams, TranslationService, ToolbarService, DownloadService, $window) {
    var ctrl = this;
    ctrl.controlTypes = ['ctu', 'ctt', 'prj', 'ctrlA', 'ctrlB', 'ctrlC', 'ctrlD', 'crd', 'psp', 'asn', 'ino', 'loc', 'eko', 'ekg', 'net', 'act'];
    var blhId = $routeParams.id;

    $scope.showHistory = false;
    $scope.showComments = true;
    $scope.showItems = true;
    $scope.showItemControl = {};
    $scope.ctrlRequired = {};

    ctrl.getData = function () {
        dataGen.getData($scope, {blhId: blhId}, '/invoice/acceptunmatched/view').then(function () {
            angular.forEach($scope.data.items, function (item) {
                for (var key in item.control) {
                    $scope.ctrlRequired[item.pos+"."+key] = item.control[key].showMust;
                }
            });
            defineButtons();
        });
    };

    ctrl.save = function () {
        return saveInternal().then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    ctrl.accept = function () {
        return saveInternal().then(function () {
            dataGen.postAsForm($scope, {blhId: blhId}, '/invoice/acceptunmatched/accept').then(function () {
                BackService.back();
                ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            });
        });
    };

    ctrl.toggleHistory = function () {
        $scope.showHistory = !$scope.showHistory;
    }

    ctrl.toggleComments = function () {
        $scope.showComments = !$scope.showComments;
    }

    ctrl.toggleItems = function () {
        $scope.showItems = !$scope.showItems;
    }

    ctrl.toggleItemControls = function (pos) {
        $scope.showItemControl[pos] = !$scope.showItemControl[pos];
    }

    ctrl.showItemControls = function (pos) {
        if (!!$scope.showItemControl[pos]) {
            return true;
        }
        var ctrlDTO = $scope.data.items[Number(pos) - 1].control;
        if (ctrlDTO) { // any ctrl set? => show the inputs
            for (var i = 0; i < ctrl.controlTypes.length; i++) {
                var prop = ctrlDTO[ctrl.controlTypes[i]];
                if (prop && prop.set && prop.set.length) {
                    return true;
                }
            }
        }
        return false;
    }

    ctrl.getArchivedFile = function () {
        DownloadService.openDownloadPost('/invoice/archive/download', {paramName: "archiveNo", paramValue: $scope.data.archiveNumber.value})
    }

    ctrl.formatAddressValue = function (value) {
        if(value) {
            return value.replace(/,\s/g, '<br/>');
        }
        return '';
    }

    ctrl.showControl = function (item, type) {
        if (item && item.control) {
            var ctrl = item.control[type];
            return ctrl && ($scope.showItemControl[item.pos] || $scope.ctrlRequired[item.pos + "." + type] || (ctrl.set && ctrl.set.length > 0));
        }
    };

    ctrl.requireCtrl = function (item, type) {
        return $scope.ctrlRequired[item.pos+"."+type];
    };

    ctrl.changeAat = function (aatId, item) {
        var dataObj = {aatId: aatId,
            item: item,
            blhId: blhId
        };
        dataGen.postAsForm({}, dataObj, "invoice/acceptunmatched/changeaat").then(function (response) {
            if (response && response.data) {
                item.control = response.data.control;
                for (var key in response.data.control) {
                    $scope.ctrlRequired = {};
                    $scope.ctrlRequired[item.pos+"."+key] = item.control[key].showMust;
                }
            }
        })
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.accept,
                action: ctrl.accept,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function resetEditUsers () {
        dataGen.postAsForm({}, {blhId: blhId}, '/invoice/reseteditusers');
    }

    function saveInternal () {
        return dataGen.postAsForm($scope, {data: $scope.data}, '/invoice/acceptunmatched/save');
    }

    // onbeforeunload is not a perfect solution, because ist also gets called on reload (F5 etc.).
    // But it still kind of works here since on reload the data es retrieved from the backend again,
    // which also sets the edit user again. The only downside is that reload basically counts as
    // leaving and reopening the dialog.
    $window.onbeforeunload = resetEditUsers;
    $scope.$on('$destroy', resetEditUsers);

    ctrl.getData();
}